import { render, staticRenderFns } from "./AMCreate.vue?vue&type=template&id=56da338d&"
import script from "./AMCreate.vue?vue&type=script&lang=js&"
export * from "./AMCreate.vue?vue&type=script&lang=js&"
import style0 from "./AMCreate.vue?vue&type=style&index=0&id=56da338d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports